import { tv } from 'tailwind-variants';

const modeIcon = {
	EMERGENCY: '🚨',
	CLEAN: '💧',
};

export const ModeIndicator = ({ modeIndicator }) => {
	const variants = tv({
		base: 'mt-[15px] text-3xl',
		variants: {
			modeIndicator: {
				CLEAN: 'animate-blinkGlowBlue',
				EMERGENCY: 'animate-blinkGlowRed',
			},
		},
	});
	return (
		<div className={variants({ modeIndicator })}>{modeIcon[modeIndicator]}</div>
	);
};
